/*! @azure/msal-common v13.3.3 2024-06-06 */
'use strict';

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var AzureCloudInstance;
(function (AzureCloudInstance) {
  // AzureCloudInstance is not specified.
  AzureCloudInstance[AzureCloudInstance["None"] = 0] = "None";
  // Microsoft Azure public cloud
  AzureCloudInstance["AzurePublic"] = "https://login.microsoftonline.com";
  // Microsoft PPE
  AzureCloudInstance["AzurePpe"] = "https://login.windows-ppe.net";
  // Microsoft Chinese national cloud
  AzureCloudInstance["AzureChina"] = "https://login.chinacloudapi.cn";
  // Microsoft German national cloud ("Black Forest")
  AzureCloudInstance["AzureGermany"] = "https://login.microsoftonline.de";
  // US Government cloud
  AzureCloudInstance["AzureUsGovernment"] = "https://login.microsoftonline.us";
})(AzureCloudInstance || (AzureCloudInstance = {}));
export { AzureCloudInstance };